import React from 'react';
import './lifeStyleImages.css';
import { IImage } from '../../../../../utils/types/contentful';
import { Image } from '../../../../UI/Media';

export interface LifestyleImagesProps {
  images: IImage;
}

export const LifestyleImages: React.FC<LifestyleImagesProps> = ({ images }) => (
  <div className='hidden lg:flex divide-x border-t border-b w-screen'>
    {images?.map((image) => (
      <div className='w-1/2 lifestyle-image'>
        <Image
          {...image}
          width='100%'
          height='100%'
          objectFit='cover'
        />
      </div>
    ))}
  </div>
);
